import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { sans as zoram, lineHeight, fontSize13, fontWeightBold, fontWeightNormal } from "@churchofjesuschrist/eden-style-constants";
import shared from "./shared";
import { AppearanceInvert } from "@churchofjesuschrist/eden-appearance";
import { jsx as _jsx } from "react/jsx-runtime";
const Container5 = styled.div.withConfig({
  componentId: "sc-1wnkqiv-0"
})(["font-family:", ";font-weight:", ";line-height:", ";font-size:", ";", ";& b,& strong{font-weight:", ";}"], zoram, fontWeightNormal, lineHeight, fontSize13, shared, fontWeightBold);
const Text5 = _ref => {
  let {
    children,
    renderAs = "div",
    ...props
  } = _ref;
  return /*#__PURE__*/_jsx(AppearanceInvert, {
    inverted: props.inverted,
    children: /*#__PURE__*/_jsx(Container5, {
      as: renderAs,
      ...props,
      children: children
    })
  });
};
Text5.displayName = "Text5";
Text5.propTypes = {
  /** Content */
  children: PropTypes.node.isRequired,
  /** What html tag or custom react element to render the text as */
  renderAs: PropTypes.elementType,
  /** Whether to apply styles that help the text stand out on a dark background. (deprecated) */
  inverted: PropTypes.bool
};
export default Text5;